<template>
  <b-form @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.id)">
    <div class="row">
      <div class="col">
        <b-card>
          <template #header>
            <b>Voucher</b>
          </template>

          <form-text v-model="form.code" name="code" maxlength="16" :required="true">
            <template #note>
              <small class="text-muted">Max length: 16; must be alpha-numerical</small>
            </template>
          </form-text>
          <form-text v-model="form.description" name="description" maxlength="32">
            <template #note>
              <small class="text-muted"
                >Max length: 32; will be used as invoice line item title</small
              >
            </template>
          </form-text>
          <form-bootstrap-radio v-model="form.type" name="type" :options="types" />
          <div class="voucher-value-row">
            <form-text
              v-model="form.value"
              name="value"
              :required="true"
              :is-number="true"
              min="0"
              :max="form.type === 'Percentage' ? 100 : null"
            >
              <template #prepend>
                <div v-if="form.type === 'Amount'">
                  <span class="input-group-text">$</span>
                </div>
              </template>
              <template #append>
                <div v-if="form.type === 'Percentage'">
                  <span class="input-group-text">%</span>
                </div>
              </template>
            </form-text>
          </div>
          <form-date v-model="form.start" name="start" value-format="yyyy-MM-dd">
            <template #note>
              <small class="text-muted">Leave empty if not restricted by time</small>
            </template>
          </form-date>
          <form-date v-model="form.expiry" name="expiry" value-format="yyyy-MM-dd">
            <template #note>
              <small class="text-muted">Leave empty if not restricted by time</small>
            </template>
          </form-date>

          <form-text v-model="form.limit" name="limit" :is-number="true">
            <template #note>
              <small class="text-muted">Leave empty if unlimited</small>
            </template>
          </form-text>
        </b-card>
      </div>
    </div>

    <b-card-footer class="mb-5">
      <div class="row">
        <div class="col text-right">
          <button class="btn btn-primary" :disabled="form.notReady()">
            <font-awesome-icon v-if="form.busy" spin :icon="['fal', 'spinner']" />
            <font-awesome-icon v-else :icon="['fal', 'check']" />
            {{ crud.getAction() === "create" ? "Create" : "Save" }}
          </button>
        </div>
      </div>
    </b-card-footer>
  </b-form>
</template>

<script type="text/babel">
import format from "../../mixins/format";

const types = ["Percentage", "Amount"];

export default {
  mixins: [format],

  data() {
    return {
      types,

      crud: null,
      form: new window.AppForm({
        code: null,
        description: null,
        type: null,
        value: null,
        start: null,
        expiry: null,
        limit: null,
      }),
    };
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.crud = new window.AppCrud("voucher");

      this.form.reset();

      if (this.crud.getAction() !== "create") {
        this.crud.initFormData(this.form).then(() => {
          this.form.type = this.form.type ? this.form.type : "Percentage";
        });
      }
    },

    onSubmit() {
      this.form.code = this.form.code.toUpperCase();

      this.form.start = format.methods.formatLocalDateToUTC(this.form.start);
      this.form.expiry = format.methods.formatLocalDateToUTC(this.form.expiry);

      this.crud.submit(this.form).then((response) => {
        if (this.crud.getAction() === "create") {
          window.toastr.success("Voucher created!", "Success");

          this.$router.push(
            {
              name: "vouchers.edit",
              params: { id: response.voucher.id },
            },
            () => {
              this.init();
            }
          );
        } else {
          this.init();
          window.toastr.success("Voucher updated!", "Success");
        }
      });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
::v-deep .voucher-value-row .input-group {
  max-width: 175px;
}
</style>
